<template>
  <div class="block">
    <input
        :placeholder="placeholder"
        :type="isPasswordVisible"
        :value="modelValue"
        @input="onInput"
        class="block__input"
    >
    <button
        @click.prevent="setPasswordVisible"
        class="block__eyes"
        v-if="type === 'password'"
    >
      <img v-if="isPasswordVisible === 'password'" src="@icons/eyeClosed.svg" alt="eye" loading="lazy">
      <img v-else src="@icons/eyeOpened.svg" alt="eye" loading="lazy">
    </button>
    <p v-if="!validate" class="block__error">{{ errorMessage }}</p>
  </div>
</template>

<script setup>
import {ref} from "vue";

const $emit = defineEmits()
const props = defineProps({
  type: String,
  placeholder: String,
  isError: Boolean,
  error: String,
  modelValue: [String, Number],
  rules: Array
})

const isPasswordVisible = ref(props.type)
const setPasswordVisible = () => {
  if (isPasswordVisible.value === 'password') {
    isPasswordVisible.value = 'text'
    return
  }
  isPasswordVisible.value = 'password'
}

const validate = ref(true)
const errorMessage = ref('')
const onInput = (e) => {
  let result = true

  props.rules?.forEach((rule) => {
    result = rule((e.target).value)

    if (result !== true) {
      errorMessage.value = String(result)
      result = false
    }
  })

  validate.value = result

  return $emit('update:modelValue', (e.target).value)
}
</script>

<style lang="scss" scoped>
.block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  position: relative;

  &__input {
    width: 100%;
    border-radius: 16px;
    border: 1px solid #008ECC;
    background-color: $white;
    box-shadow: 0 0 14.6px 0 rgba(0, 0, 0, 0.05);
    padding: 10px 20px;
    background-repeat: no-repeat;
    background-position: right 15px center;

    color: #222;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;

    &::placeholder {
      color: #2B2B2B;
    }
  }

  &__eyes {
    cursor: pointer;
    position: absolute;
    right: 23px;
    top: 14px;
    background-color: transparent;
    display: grid;
    place-items: center;
  }

  &__error {
    color: $error;
    font-size: 12px;
    font-weight: 500;
    animation: fadeInUp 0.3s ease;

    @keyframes fadeInUp {
      0% {
        opacity: 0;
        transform: translateY(-50%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}

@media (max-width: 500px) {
  .block {
    &__input {
      font-size: 16px;
    }
  }
}
</style>